// extracted by mini-css-extract-plugin
module.exports = {"root":"StripeCard_root__IciIt","title":"StripeCard_title__24ais","imageBox":"StripeCard_imageBox__rpfD5","rotation":"StripeCard_rotation__KNefE"};